import { useContext } from "react";

import { GqlPermissions } from "~/__generated__";

import UserContext from "../context/UserContext";

export default function useHasTenantPermission(permission: GqlPermissions) {
    const userInfo = useContext(UserContext);

    if (userInfo?.user.tenantRole?.permissions.some(perm => perm === GqlPermissions.Administrator)) return true;

    return userInfo?.user.tenantRole?.permissions.some(perm => perm === permission) || false;
}
